import React from "react";
import { Alert, Button, FormControl, Paper, TextField, Typography } from "@mui/material";

export default function AdminForm(props) {
  const {
    id,
    formName,
    contentAsText,
    submitting,
    parseError,
    onFormNameChange,
    onContentChange,
    handleSave,
    onCancelAction,
  } = props;

  return (
    <React.Fragment>
      <Paper style={{ padding: 16 }}>
        <Typography variant="h6">Edition du formulaire #{id || "nouveau"}</Typography>

        <FormControl fullWidth>
          <TextField
            label="Nom du formulaire"
            margin="normal"
            variant="outlined"
            value={formName}
            onChange={onFormNameChange}
            disabled={submitting}
          />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            label="Contenu JSON du formulaire"
            margin="normal"
            variant="outlined"
            value={contentAsText}
            onChange={onContentChange}
            disabled={submitting}
            multiline
            minRows={14}
          />
        </FormControl>

        {parseError ? (
          <Alert severity="error" style={{ marginTop: 12 }}>
            JSON invalide: {parseError}
          </Alert>
        ) : null}

        <div style={{ display: "flex", justifyContent: "space-around", marginTop: 20 }}>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={submitting || !formName || !contentAsText || !!parseError}
          >
            {submitting ? "Enregistrement..." : "Sauver"}
          </Button>
          <Button variant="outlined" onClick={onCancelAction} disabled={submitting}>
            Annuler
          </Button>
        </div>
      </Paper>
    </React.Fragment>
  );
}
